<script setup lang="ts">
defineProps<{
  seoTextHtml?: string
}>()
</script>

<template>
  <div class="bx-content bx-content__continuous-text bx-recipe__seo-text bx-typo--content-continuous-text"
       v-html="seoTextHtml" />
</template>
